/**
 * A shim for performance.now method which falls back
 * to Date.now if the first one is not supported.
 *
 * @returns {Timestamp}
 */
export default (function () {
    if (window.performance && window.performance.now) {
        return () => window.performance.now();
    }

    return () => Date.now();
})();


//////////////////
// WEBPACK FOOTER
// ./node_modules/intersection-observer-polyfill/src/shims/performance.now.js
// module id = 425
// module chunks = 1